import { useState, FC } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import MainContainer from '../../ui_components/MainContainer';
import styled from 'styled-components';
import colors from '../../../styles/colors';
import type { Arena } from '../../../types';
import type { PPVSpecific } from '../../../types/models/ppv';

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & .name-arena {
        font-size: 23px;
        font-weight: 600;
        text-align: center;
        margin: 0;
        padding: 0;
    }

    & .state-arena {
        font-size: 16px;
        font-weight: 400;
        text-align: center;
    }
`

const BoxPoster = styled.div`
    width: 50%;
    height: 200px;
    border: 1px solid black;
    margin-bottom: 10px;

    & img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
    }
`

const BoxListPpv = styled.div`
    width: 70%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const AllPpvContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
`


const CardPpv = styled.div`
    width: 35%;
    height: 150px;
    border: 1px solid white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${colors.bgColorBlack2};

    &:hover {
        cursor: pointer;
        background-color: ${colors.bgColorBordeaux};
    }
`

const BoxTopPoster = styled.div`
    width: 100%;
    height: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;

    & img {
        width: 100%;
        height: 100%;
        border: 1px solid white;
        object-fit: cover;
    }
`

const BoxBottomInfo = styled.div`
    width: 100%;
    height: 20%;
    padding: 0 5px;

    & .ppv-text {
        font-size: 10px;
        font-weight: 600;
        text-transform: uppercase;
        text-align: center;
        color: white;
        margin: 0;
        padding: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`

interface ArenaPpv extends Omit<PPVSpecific, 'ppv_description'> {
    ppv_description: {
        name: string;
    };
}

interface ArenaWithPpvs extends Omit<Arena, 'ppvs'> {
    ppvs: ArenaPpv[];
}

const SingleArenaMobile: FC = () => {
    const [arenaData, setArenaData] = useState<ArenaWithPpvs>(useLoaderData() as ArenaWithPpvs);
    const navigate = useNavigate();

    const navigateToPpv = (id: number, name: string): void => {
        navigate(`/ppv/specific/i_${id}_d_${name}`);
    }

    return (
        <MainContainer isMobile={true} className='main-container-single-arena-mobile'>
            <Wrapper className='wrapper-single-arena-mobile'>
                <h1 className='name-arena'>{arenaData.name}</h1>
                <h6 className='state-arena'>{arenaData.state}, {arenaData.city}</h6>
                <BoxPoster className='box-poster'>
                    <img src={process.env.REACT_APP_STORAGE_URL + arenaData.img_path} alt={arenaData.name} />
                </BoxPoster>

                <BoxListPpv className='box-list-ppv'>
                    <h2 className='title-ppv'>PPV Ospitati</h2>

                    <AllPpvContainer className='all-ppv-container'>
                        {arenaData.ppvs.map((ppv) => (
                            <CardPpv className='card-ppv' key={ppv.id} onClick={() => navigateToPpv(ppv.id, ppv.ppv_description.name)}>
                                <BoxTopPoster className="box-top-poster">
                                    <img src={process.env.REACT_APP_STORAGE_URL + ppv.img_path} alt={ppv.img_path + "_alt"} />
                                </BoxTopPoster>

                                <BoxBottomInfo className="box-bottom-info">
                                    {/* Nome piu solo anno del ppv */}
                                    <p className="ppv-text ppv-name">{ppv.ppv_description.name}</p>
                                    <p className="ppv-text ppv-year">{ppv.date.split('-')[2]}</p>
                                </BoxBottomInfo>
                            </CardPpv>
                        ))}
                    </AllPpvContainer>
                </BoxListPpv>
            </Wrapper>
        </MainContainer>
    )
}

export default SingleArenaMobile;
